/**
 * InfinitSales - API Client
 * Base axios configuration for backend communication
 */
import axios from 'axios';
import { isDelegated, endDelegation } from '../../utils/delegation';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000'
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    // Evita a página interstitial do ngrok free em chamadas XHR quando o app
    // é servido por túnel (testes multi-máquina). Inócuo fora do ngrok.
    'ngrok-skip-browser-warning': 'true',
  },
});

// Request interceptor - add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Etapa 2.2: se a sessão delegada foi revogada (ator/alvo suspenso ou
      // removido), não deslogamos o usuário — restauramos o token real dele
      // e voltamos para a tela de workspaces.
      if (isDelegated()) {
        endDelegation();
        window.location.href = '/empresa';
        return Promise.reject(error);
      }
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
